import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import Form from "./components/Form";
import { Modal } from "react-bootstrap";
import {
  getOfficeDetail,
  useStateList,
  useSuburbListE,
} from "./components/OfficeHelper";
import { AddOfficeSchema } from "../common/Validation";
import Spin from "../common/Spin";
import { API, fileUpload } from "../../config";
import { toast } from "react-toastify";
import { useBusinessList, useUserList } from "../Users/components/UserHelper";
import { formatName } from "../common/Misc";

const EditOffice = ({ officeId, toggleOfficeModal, showOffice }) => {
  const [loading, setLoading] = useState(false);
  const [officeData, setOfficeData] = useState();
  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];

  const [selectedBusinesses, setSelectedBusinesses] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);


  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.state_id = value?.state_id?.value;
    value.suburb_id = value?.suburb_id?.value;

    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );

    if(selectedBusinesses){
      if(selectedBusinesses.length > 0){
        for(let i = 0; i < selectedBusinesses.length; i++){
          formData.append(`business_ids[${i}]`, selectedBusinesses[i]);
        }
      }
    }

    if(selectedUsers){
      if(selectedUsers.length > 0){
        for(let i = 0; i < selectedUsers.length; i++){
          formData.append(`user_ids[${i}]`, selectedUsers[i]);
        }
      }
    }

    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.OFFICE}/${officeId}`, formData);
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleOfficeModal();
        setSelectedBusinesses([]);
        setSelectedUsers([]);
      }
      return data?.data;
    } catch (error) {
      setOfficeData(value);
      setSelectedBusinesses([]);
      setSelectedUsers([]);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getOfficeDetail(officeId);
        setOfficeData(data);
        setSelectedBusinesses(data?.business_ids)
        setSelectedUsers(data?.user_ids)
        setLoading(false);
      } catch (e) {
        setOfficeData(null);
      }
    }
    fetchData();
  }, [officeId]);

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === officeData?.state_id
  );

  // Suburb
  const { suburbLoading, suburbList = [] } = useSuburbListE(
    officeData?.state_id
  );
  const suburbListing = suburbList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const suburb = suburbListing?.find(
    (item) => item?.value === officeData?.suburb_id
  );

  
  //Business List
  const { businessLoading, businessList = [] } = useBusinessList();
  const businessListing = businessList?.map((item) => {
    const name = item?.business_name;
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });


  //User List
  const { userLoading, userList = [] } = useUserList();
  const userListing = userList?.map((item) => {
    const name = formatName(item?.first_name, item?.last_name);
    const id = item?.client_user?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });

  return (
    <>
      <Modal
        size="lg"
        show={showOffice}
        onHide={toggleOfficeModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Office Details
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              street: officeData?.street,
              postal_code: officeData?.postal_code,
              state_id: state,
              suburb_id: suburb,
              user_ids: selectedUsers,
              business_ids: selectedBusinesses
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddOfficeSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {(loading || userLoading || businessLoading) && <Spin />}
                  <Form
                    values={values}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    formValues={formValues}
                    overwrittenFields={overwrittenFields}
                    existingValues={existingValues}
                    toggleOfficeModal={toggleOfficeModal}
                    stateListing={stateListing}
                    suburbListing={suburbListing}
                    stateLoading={stateLoading}
                    suburbLoadingE={suburbLoading}
                    businessLoading={businessLoading}
                    businessListing={businessListing}
                    selectedBusinesses={selectedBusinesses}
                    setSelectedBusinesses={setSelectedBusinesses}
                    userListing={userListing}
                    userLoading={userLoading}
                    setSelectedUsers={setSelectedUsers}
                    selectedUsers={selectedUsers}
                  />
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditOffice;
